/* eslint-disable no-param-reassign */

export default {

    state: {
        e4Config: {
            improvementInitiative: {},
            boilerOperatingParameters: {}, // only for E4Booling
            coolingOperatingParameters: {}, // only for E4Cooling
            baselineData: {},

        },
    },
    getters: {
        e4Config: state => state.e4Config,
    },
    mutations: {
        setE4Config(state, datas) {
            Object.keys(datas).forEach(key => {
                if (state.e4Config[key]) {
                    state.e4Config[key] = {
                        ...state.e4Config[key],
                        ...datas[key],
                    };
                }
            });
        },
        resetE4Config(state) {
            state.e4Config = {
                improvementInitiative: {},
                boilerOperatingParameters: {},
                coolingOperatingParameters: {},
                baselineData: {},
            };
        },
        resetE4Fuels(state) {
            state.e4Config.boilerOperatingParameters.fuels.forEach(fuel => {
                fuel.unit = null;
                fuel.network = null;
                fuel.component = null;
                fuel.analysisConfiguration = null;
                fuel.analysisList = [];
                if (fuel.density) {
                    fuel.density.value = null;
                    fuel.density.unit = null;
                }
            });
        },
    },
    actions: {
        setE4Config({ commit }, e4Config) {
            commit('setE4Config', e4Config);
        },
        resetE4Config({ commit }) {
            commit('resetE4Config');
        },
        resetE4Fuels({ commit }) {
            commit('resetE4Fuels');
        },
    },
};
